import { Amplify } from 'aws-amplify';

export const configureAmplify = () => {
  const userPoolId = import.meta.env.VITE_COGNITO_USER_POOL_ID;
  const userPoolClientId = import.meta.env.VITE_COGNITO_CLIENT_ID;
  const region = import.meta.env.VITE_COGNITO_REGION || 'eu-central-1';

  // Validate required configuration
  if (!userPoolId || !userPoolClientId) {
    console.error('Missing Cognito configuration:', {
      userPoolId: userPoolId ? '✓' : '✗ MISSING',
      userPoolClientId: userPoolClientId ? '✓' : '✗ MISSING',
      region: region ? '✓' : '✗ MISSING',
    });
    throw new Error(
      'Cognito configuration is missing. Please check your environment variables.'
    );
  }

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId,
        loginWith: {
          email: true,
        },
        signUpVerificationMethod: 'code',
        userAttributes: {
          email: {
            required: true,
          },
        },
        passwordFormat: {
          minLength: 8,
          requireLowercase: true,
          requireUppercase: true,
          requireNumbers: true,
          requireSpecialCharacters: true,
        },
      },
    },
  });

  console.log('✓ Amplify configured successfully with region:', region);
};
